export const userIndex = {
  menuItem: {
    fontFamily: 'Inter',
    fontSize: 'var(--font-size-14)',
    fontWeight: '500 !important',
    lineHeight: 'var(--line-height-20)',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center'
  }
};
